module.exports = __webpack_public_path__ + "05_glasses_brown.d978bd4e.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/momoro/mama/layer4/05_glasses_brown.png
// module id = MoTH
// module chunks = 0